"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const delimiters = require("./constants");
const clean_text_1 = require("./utils/clean-text");
const remove_punctuation_1 = require("./utils/remove-punctuation");
exports.getParagraphTokens = (text) => {
    return exports.getTokens(text, delimiters.paragraphDelimiter);
};
exports.getSentenceTokens = (text) => {
    return exports.getTokens(text, delimiters.sentenceDelimiters);
};
exports.getSubSentenceTokens = (text) => {
    return exports.getTokens(text, delimiters.subSentenceDelimiters).map(token => remove_punctuation_1.removePunctuations(token));
};
exports.getWordTokens = (text) => {
    return exports.getTokens(text, delimiters.wordDelimiter).map(token => remove_punctuation_1.removePunctuations(token));
};
exports.getTokens = (text, delimiterRegexp) => {
    return (delimiterRegexp === delimiters.paragraphDelimiter ?
        clean_text_1.cleanRootText(text) :
        clean_text_1.cleanParagraphText(text))
        .split(delimiterRegexp).map(token => token.trim()).filter(token => !!token);
};
//# sourceMappingURL=text-tokenizer.js.map